/** @jsxImportSource react */
import React from 'react';
import { 
    LayoutDashboard, PieChart, Settings, Users, Calculator, Menu, X, LogOut, Plus, ChevronDown, CheckCircle2,
    Clock, ExternalLink, Trash2, Bell, Warehouse as WarehouseLucide, Weight as WeightLucide, Scaling, Info, Truck, ShoppingBag, Inbox,
    Globe, Tag, Rocket, Handshake, BrainCircuit, Box, type LucideProps, ClipboardList, Package, Loader, CircleDollarSign, ListChecks
} from 'lucide-react';
import { useTranslation } from './i18n';

export const COUNTRY_CODES = [
  { name: 'Iraq (+964)', code: '+964' },
  { name: 'China (+86)', code: '+86' },
  { name: 'UAE (+971)', code: '+971' },
  { name: 'USA (+1)', code: '+1' },
  { name: 'UK (+44)', code: '+44' },
];

// Lucide Icon Components
const createIcon = (IconComponent: React.ElementType) => {
    const Icon = (props: LucideProps) => <IconComponent className="h-6 w-6" strokeWidth={1.75} {...props} />;
    Icon.displayName = (IconComponent as any).displayName;
    return Icon;
};

export const LogoIcon = ({ className }: { className?: string }) => {
    const { t } = useTranslation();
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <Tag className="h-8 w-8 text-primary transform -rotate-45" />
            <span className="font-display text-2xl font-bold text-dark-800">{t('tagExpress')}</span>
        </div>
    );
};

export const DashboardIcon = createIcon(LayoutDashboard);
export const OrdersIcon = createIcon(ClipboardList);
export const ReportsIcon = createIcon(PieChart);
export const SettingsIcon = createIcon(Settings);
export const UsersIcon = createIcon(Users);
export const AccountantIcon = createIcon(Calculator);
export const HamburgerIcon = createIcon(Menu);
export const CloseIcon = createIcon(X);
export const LogoutIcon = createIcon(LogOut);
export const PlusIcon = (props: LucideProps) => <Plus className="h-5 w-5" strokeWidth={2.5} {...props} />;
export const ChevronDownIcon = (props: LucideProps) => <ChevronDown className="h-5 w-5" {...props} />;
export const CheckCircleIcon = createIcon(CheckCircle2);
export const ClockIcon = createIcon(Clock);
export const LinkIcon = (props: LucideProps) => <ExternalLink className="h-4 w-4 me-1" {...props} />;
export const TrashIcon = (props: LucideProps) => <Trash2 className="h-5 w-5" {...props} />;
export const NotificationIcon = createIcon(Bell);
export const WarehouseIcon = createIcon(WarehouseLucide);
export const WeightIcon = createIcon(WeightLucide);
export const DimensionsIcon = createIcon(Scaling);
export const InfoIcon = createIcon(Info);
export const ShippingIcon = createIcon(Truck);
export const SourcingIcon = createIcon(ShoppingBag);
export const InboxIcon = createIcon(Inbox);
export const GlobeIcon = createIcon(Globe);
export const PriceTagIcon = createIcon(Tag);
export const RocketIcon = createIcon(Rocket);
export const HandshakeIcon = createIcon(Handshake);
export const BrainIcon = createIcon(BrainCircuit);
export const CubeTransparentIcon = createIcon(Box);
export const PackageIcon = createIcon(Package);
export const LoaderIcon = createIcon(Loader);
export const DollarIcon = createIcon(CircleDollarSign);
export const PriceCheckIcon = createIcon(ListChecks);